import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=647e6774"
import script from "./latest.vue?vue&type=script&lang=js"
export * from "./latest.vue?vue&type=script&lang=js"
import style0 from "./latest.vue?vue&type=style&index=0&id=647e6774&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports